import { IS_MOCK_DATA } from "@/lib/env";
import type { StaffDataSource } from "./data-source.types";
import { createMockDataSource } from "./mock-data-source";
import { createSupabaseDataSource } from "./supabase-data-source";

export type { StaffDataSource } from "./data-source.types";

export const dataSource: StaffDataSource = IS_MOCK_DATA
  ? createMockDataSource()
  : createSupabaseDataSource();
